module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "engineerStockQuery"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择是否包含特配",
      "clearable": ""
    },
    on: {
      "change": _vm.pickingType
    },
    model: {
      value: (_vm.searchForm.type),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "type", $$v)
      },
      expression: "searchForm.type"
    }
  }, _vm._l((_vm.pickingList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库类型",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.warehouseType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "warehouseType", $$v)
      },
      expression: "searchForm.warehouseType"
    }
  }, _vm._l((_vm.stockTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "门店",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.belongDeptId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "belongDeptId", $$v)
      },
      expression: "searchForm.belongDeptId"
    }
  }, _vm._l((_vm.shopDataList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.attribute1,
        "value": item.deptId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "工程师"
    },
    model: {
      value: (_vm.searchForm.belonger),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "belonger", $$v)
      },
      expression: "searchForm.belonger"
    }
  }, _vm._l((_vm.engineersList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入物料编码"
    },
    model: {
      value: (_vm.searchForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "物料名称"
    },
    model: {
      value: (_vm.searchForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialName"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入序列号"
    },
    model: {
      value: (_vm.searchForm.code),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "品牌"
    },
    on: {
      "change": _vm.selectFormBrand
    },
    model: {
      value: (_vm.searchForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "brandId", $$v)
      },
      expression: "searchForm.brandId"
    }
  }, _vm._l((_vm.brandFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    }, [_vm._v(_vm._s(item.brandName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "品类"
    },
    on: {
      "change": _vm.selectFormCategory
    },
    model: {
      value: (_vm.searchForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "categoryId", $$v)
      },
      expression: "searchForm.categoryId"
    }
  }, _vm._l((_vm.categoryFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "selected": {
          'selected': index == 0
        },
        "label": item.categoryName,
        "value": item.categoryId
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "型号"
    },
    on: {
      "change": _vm.selectFormModel
    },
    model: {
      value: (_vm.searchForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "modelId", $$v)
      },
      expression: "searchForm.modelId"
    }
  }, _vm._l((_vm.modelFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "物料"
    },
    on: {
      "change": _vm.getEngineerStockList
    },
    model: {
      value: (_vm.searchForm.materialCoding),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialCoding", $$v)
      },
      expression: "searchForm.materialCoding"
    }
  }, _vm._l((_vm.materialFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialName,
        "value": item.materialCoding
      }
    }, [_vm._v(_vm._s(item.materialName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "23%",
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitSearch('searchForm')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "id": "tableId"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "105",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "width": "110",
      "label": "型号名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "width": "230",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "warehouseType",
      "label": "仓库类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "name",
      "label": "工程师"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum1",
      "label": "库存总量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sumPrice",
      "label": "库存价值"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "specialNumber",
      "label": "特配数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.sum2 - scope.row.sum) > 0) ? _c('span', [_vm._v("\n                        " + _vm._s(scope.row.sum1 - scope.row.sum) + "\n                    ")]) : _c('span', [_vm._v("0")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum2",
      "label": "未使用"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum3",
      "label": "已使用"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "waringCount",
      "label": "售前数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum4",
      "label": "售后数"
    }
  }), _vm._v(" "), (_vm.basicsAuth.all_serial_number) ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showSerialNumber(scope.row.materialCoding, null, scope.row.engineerId, 0)
            }
          }
        }, [_vm._v("查看")])]
      }
    }], null, false, 3691339279)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100, 1000],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-content-self",
    attrs: {
      "title": "序列号类型",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "table-filter-content"
  }, [_c('el-button', {
    class: {
      active: _vm.shift == 0
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(0)
      }
    }
  }, [_vm._v("全部序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 1
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(1)
      }
    }
  }, [_vm._v("未使用序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 2
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(2)
      }
    }
  }, [_vm._v("已使用序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 3
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(3)
      }
    }
  }, [_vm._v("售前序列号")]), _vm._v(" "), _c('el-button', {
    class: {
      active: _vm.shift == 4
    },
    on: {
      "click": function($event) {
        return _vm.handleShift(4)
      }
    }
  }, [_vm._v("售后序列号")])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "dialog-code-content",
    attrs: {
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    }
  }, _vm._l((_vm.codeList), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('p', [_vm._v(_vm._s(item.code))])])
  }), 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.numberPages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.numberPages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.numberPages.total
    },
    on: {
      "size-change": _vm.handleNumberSizeChange,
      "current-change": _vm.handleNumberCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-415b4a57","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/engineerStockQueryManage.vue
// module id = 1652
// module chunks = 0